// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"styles_checkbox__3d72q","active":"styles_active__3813f"};